// extracted by mini-css-extract-plugin
module.exports = {"summary_item":"_927a99ad28--summary_item--ONOFT","dashed_line":"_927a99ad28--dashed_line--coYQ8"};